// routes
export const HOST_API = "https://api.pupilkart.com/";
